import React from 'react';

import { MultiPackage } from '../../../../../fulfillment-planner/package/multi-package';
import {
  MULTI_PACKAGE_DROPDOWN_SELECT_FROM_ORDER_SIDEBAR,
  MULTI_PACKAGE_MODAL_OPEN_FROM_ORDER_SIDEBAR,
} from '../../../../../constants/analytics-events';
import { PackageDropdownContainer } from '../../../../../fulfillment-planner/package/dropdown/container';
import { PackageLabel } from '../../../../../fulfillment-planner/package/label';
import { Segment } from '../../../../../services/analytics-services/segment';
import { SmartFillTooltip } from '../../../../../orders/order-details/fulfillment-plan/sections/configure-shipment/smartfill-tooltip';
import { useFulfillmentPlannerContext } from '../../../../../fulfillment-planner/context';

import style from './style.module.less';

export const Package = () => {
  const { hasSmartFillDataBeenChanged, isSmartFillEnabled, smartFillMetaData } = useFulfillmentPlannerContext();

  const hasSmartFillPackageChanged = hasSmartFillDataBeenChanged?.package;
  const shouldShowSmartFillIcon = isSmartFillEnabled && !hasSmartFillPackageChanged;

  const onTrackChangePackageSet = (packageSet) => {
    Segment.trackEvent(MULTI_PACKAGE_DROPDOWN_SELECT_FROM_ORDER_SIDEBAR, {
      type: MULTI_PACKAGE_DROPDOWN_SELECT_FROM_ORDER_SIDEBAR,
      packageSetName: packageSet?.name,
    });
  };

  const onTrackOpenMultiPackageModal = () => {
    Segment.trackEvent(MULTI_PACKAGE_MODAL_OPEN_FROM_ORDER_SIDEBAR, {
      type: MULTI_PACKAGE_MODAL_OPEN_FROM_ORDER_SIDEBAR,
    });
  };

  return (
    <React.Fragment>
      <div className={style.label}>
        <SmartFillTooltip count={smartFillMetaData?.Package?.TimesUsed} shouldHideTooltip={!shouldShowSmartFillIcon}>
          <PackageLabel />
        </SmartFillTooltip>
      </div>
      <PackageDropdownContainer onTrackChangePackageSet={onTrackChangePackageSet} />
      <div className={style['multi-package']}>
        <MultiPackage onTrackOpenMultiPackageModal={onTrackOpenMultiPackageModal} />
      </div>
    </React.Fragment>
  );
};
